export const getURLSlug = (queryString, split) => queryString.split(`${split}`)[1];
export default getURLSlug;
